module.exports = __webpack_public_path__ + "img/pager2-quick-icon3.56b6c0a8.png";